export const VERIFY_AUTH = "/auth/admin/";
export const FETCH_USER_PROFILE = "/administration/";
